<dx-scroll-view>
  <div class="dx-fieldset">
    <div class="dx-field">
      <div class="dx-field-label">{{ 'Name' | translate }}</div>
      <div class="dx-field-value">
        <dx-text-box [(value)]="prompt.name" [showClearButton]="true" />
      </div>
    </div>

    <div class="dx-field">
      <div class="dx-field-label">{{ 'Model' | translate }}</div>
      <div class="dx-field-value">
        <dx-select-box
          [items]="models"
          [(value)]="selectedModel"
          [displayExpr]="displayExprFn"
          (onValueChanged)="onModelChanged($event)"
        />
      </div>
    </div>

    <div class="dx-field">
      <div class="dx-field-label">{{ 'Max. Output Länge in Zeichen' | translate }}</div>
      <div class="dx-field-value">
        <dx-number-box [(value)]="prompt.maxLenght" />
      </div>
    </div>

    <div class="dx-field">
      <div class="dx-field-label">{{ 'Prompt' | translate }}</div>
      <div class="dx-field-value">
        <div class="dx-card mb-4">
          <div style="display: flex; align-items: center">
            <dx-lookup
              style="width:70%"
              [searchExpr]="['field', 'translation', 'group']"
              displayExpr="field"
              [dataSource]="dataSource"
              [grouped]="true"
              searchEnabled="true"
              [inputAttr]="{ 'aria-label': 'Grouped lookup' }"
              dropDownCentered="false"
              [(value)]="selectedTemplateItemField"
            >
              <div *dxTemplate="let data of 'item'">{{ data.translation }}  [{{data.field}}]</div>
            </dx-lookup>
            <dx-button text="Platzhalter erstellen" (onClick)="generatePlaceholder()" />
          </div>

          <dx-text-area #promptTextArea [(value)]="prompt.prompt" autoResizeEnabled="true" />
        </div>
      </div>
    </div>
  </div>
</dx-scroll-view>
